// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/About-Amber": [9],
		"/Criminal-Defense": [10],
		"/DMV-Hearing": [11],
		"/DUI": [12],
		"/Domestic Violence": [13],
		"/Expungement": [14],
		"/Gun Charges": [15],
		"/Locations": [16],
		"/Locations/sacramento": [17],
		"/Locations/san-diego": [18],
		"/admin": [85,[6]],
		"/admin/appsettings": [86,[6]],
		"/admin/case-management": [87,[6]],
		"/admin/extensions": [88,[6]],
		"/admin/operations": [89,[6]],
		"/admin/roles": [90,[6]],
		"/admin/submissions": [91,[6]],
		"/admin/vehicle-reports": [92,[6]],
		"/assault-with-deadly-weapon-attorney-sacramento": [93],
		"/best-criminal-defense-lawyer-in-elk-grove": [94],
		"/best-dui-lawyer-in-elk-grove": [95],
		"/best-dui-lawyer-in-sacramento-ca": [96],
		"/best-dui-lawyers-sacramento-county": [97],
		"/contact": [98],
		"/domestic-violence-attorneys-sacramento": [99],
		"/finding-your-legal-niche": [100],
		"/news": [101],
		"/no-you-can-t-say-that-in-court": [102],
		"/portal": [103,[7]],
		"/portal/cases": [104,[7]],
		"/portal/submissions": [105,[7]],
		"/practice-areas": [106],
		"/[lang]": [19],
		"/[lang]/About-Amber": [20],
		"/[lang]/Criminal-Defense": [21],
		"/[lang]/DMV-Hearing": [22],
		"/[lang]/DUI": [23],
		"/[lang]/Domestic Violence": [24],
		"/[lang]/Expungement": [25],
		"/[lang]/Gun Charges": [26],
		"/[lang]/Locations": [27],
		"/[lang]/Locations/sacramento": [28],
		"/[lang]/Locations/san-diego": [29],
		"/[lang]/admin": [63,[4]],
		"/[lang]/admin/appsettings": [64,[4]],
		"/[lang]/admin/case-management": [65,[4]],
		"/[lang]/admin/extensions": [66,[4]],
		"/[lang]/admin/operations": [67,[4]],
		"/[lang]/admin/roles": [68,[4]],
		"/[lang]/admin/submissions": [69,[4]],
		"/[lang]/admin/vehicle-reports": [70,[4]],
		"/[lang]/assault-with-deadly-weapon-attorney-sacramento": [71],
		"/[lang]/best-criminal-defense-lawyer-in-elk-grove": [72],
		"/[lang]/best-dui-lawyer-in-elk-grove": [73],
		"/[lang]/best-dui-lawyer-in-sacramento-ca": [74],
		"/[lang]/best-dui-lawyers-sacramento-county": [75],
		"/[lang]/contact": [76],
		"/[lang]/domestic-violence-attorneys-sacramento": [77],
		"/[lang]/finding-your-legal-niche": [78],
		"/[lang]/news": [79],
		"/[lang]/no-you-can-t-say-that-in-court": [80],
		"/[lang]/portal": [81,[5]],
		"/[lang]/portal/cases": [82,[5]],
		"/[lang]/portal/submissions": [83,[5]],
		"/[lang]/practice-areas": [84],
		"/[lang]/[area]": [30],
		"/[lang]/[area]/About-Amber": [31],
		"/[lang]/[area]/Criminal-Defense": [32],
		"/[lang]/[area]/DMV-Hearing": [33],
		"/[lang]/[area]/DUI": [34],
		"/[lang]/[area]/Domestic Violence": [35],
		"/[lang]/[area]/Expungement": [36],
		"/[lang]/[area]/Gun Charges": [37],
		"/[lang]/[area]/Locations": [38],
		"/[lang]/[area]/Locations/sacramento": [39],
		"/[lang]/[area]/Locations/san-diego": [40],
		"/[lang]/[area]/admin": [41,[2]],
		"/[lang]/[area]/admin/appsettings": [42,[2]],
		"/[lang]/[area]/admin/case-management": [43,[2]],
		"/[lang]/[area]/admin/extensions": [44,[2]],
		"/[lang]/[area]/admin/operations": [45,[2]],
		"/[lang]/[area]/admin/roles": [46,[2]],
		"/[lang]/[area]/admin/submissions": [47,[2]],
		"/[lang]/[area]/admin/vehicle-reports": [48,[2]],
		"/[lang]/[area]/assault-with-deadly-weapon-attorney-sacramento": [49],
		"/[lang]/[area]/best-criminal-defense-lawyer-in-elk-grove": [50],
		"/[lang]/[area]/best-dui-lawyer-in-elk-grove": [51],
		"/[lang]/[area]/best-dui-lawyer-in-sacramento-ca": [52],
		"/[lang]/[area]/best-dui-lawyers-sacramento-county": [53],
		"/[lang]/[area]/contact": [54],
		"/[lang]/[area]/domestic-violence-attorneys-sacramento": [55],
		"/[lang]/[area]/finding-your-legal-niche": [56],
		"/[lang]/[area]/news": [57],
		"/[lang]/[area]/no-you-can-t-say-that-in-court": [58],
		"/[lang]/[area]/portal": [59,[3]],
		"/[lang]/[area]/portal/cases": [60,[3]],
		"/[lang]/[area]/portal/submissions": [61,[3]],
		"/[lang]/[area]/practice-areas": [62]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);